import { v4 as uuidv4 } from 'uuid';
import { storageFactory } from '@domain-group/fe-helper';
var storage = storageFactory({
  name: 'AllhomesAnalytics'
});
var userTokenLocalStorageKey = 'aha_ut';
var retrieveUserToken = () => {
  var userToken = storage.getItem(userTokenLocalStorageKey);
  if (!userToken) {
    userToken = uuidv4();
    storage.setItem(userTokenLocalStorageKey, userToken);
  }
  return userToken;
};
export default retrieveUserToken;